import { render, staticRenderFns } from "./joinRecord.vue?vue&type=template&id=2bb67dfc&scoped=true"
import script from "./joinRecord.vue?vue&type=script&lang=js"
export * from "./joinRecord.vue?vue&type=script&lang=js"
import style0 from "./joinRecord.vue?vue&type=style&index=0&id=2bb67dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb67dfc",
  null
  
)

export default component.exports